import React from 'react';
import { Stack, Button } from '@mui/material';
import i18next from 'i18next';
import { Translate } from '@mui/icons-material';
import { themeColors } from 'Global/JsxThemeColor/JsxThemeColor';

const EditLanguageList = ({
  setShowLangEditor,
  isLanguageEditAllowed,
  AccessRoles,
  edit_lang_msg,
}) => {
  // console.log(
  //   '--------->',
  //   isLanguageEditAllowed,
  //   AccessRoles
  // );

  return (
    <React.Fragment>
      {isLanguageEditAllowed &&
      AccessRoles?.includes('admin') ? (
        <Stack
          direction={
            i18next.language === 'en'
              ? 'row'
              : 'row-reverse'
          }
          alignItems="center"
          justifyContent="space-between"
        >
          <Button
            variant="contained"
            sx={{
              color: `${themeColors.ColorPrimary} !important`,
            }}
            onClick={() => {
              setShowLangEditor((prev) => !prev);
            }}
            fullWidth
            startIcon={<Translate />}
          >
            {edit_lang_msg}
          </Button>
        </Stack>
      ) : (
        <></>
      )}
    </React.Fragment>
  );
};

export default EditLanguageList;
